import Axios from 'axios';
import baseURL from '@/config/url';
import { Message, Modal } from 'iview';
import { TOKEN_KEY } from '@/libs/util';
import TUIChatEngine from '@tencentcloud/chat-uikit-engine';
class httpRequest {
  constructor() {
    this.options = {
      method: '',
      url: ''
    };
    // 存储请求队列
    this.queue = {};
  }
  // 销毁请求实例
  destroy(url) {
    delete this.queue[url];
    const queue = Object.keys(this.queue);
    return queue.length;
  }
  // 请求拦截
  interceptors(instance, url) {
    // 添加请求拦截器
    instance.interceptors.request.use(
      config => {
        let accessToken = sessionStorage.getItem(TOKEN_KEY);
        if (accessToken) {
          config.headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // 在发送请求之前做些什么
        return config;
      },
      error => {
        // 对请求错误做些什么
        return Promise.reject(error);
      }
    );

    // 添加响应拦截器
    instance.interceptors.response.use(
      res => {
        let { data } = res;
        const is = this.destroy(url);
        if (!is) {
          setTimeout(() => {
            // Spin.hide()
          }, 500);
        }
        if (!(data instanceof Blob)) {
          if (data.code === 401) {
            localStorage.clear();
            Message.error('已退出登录，请重新登录');
            TUIChatEngine.logout();
            router.replace({
              name: 'login'
            });
            return Promise.reject(data);
          } else if (~res.config.url.indexOf('common/scanLogin') && data.code === 403) {
            return data;
          } else if (~res.config.url.indexOf('company-score/add')) {
            return data;
          } else if (data.code !== 200 && data.code != 501) {
            //还未创建企业
            Message.error({
              duration: 3,
              content: data.msg
            });
            return Promise.reject(data);
          }
        }
        return data;
      },
      error => {
        if (error.response.status === 401) {
          localStorage.clear();
          Message.error('登录失败');
        } else if (error.response.status === 490) {
          router.replace({
            name: 'name-card'
          });
        } else if (error.response.status === 491) {
          let msg = error.response.data && error.response.data.error && error.response.data.error.message;
          msg = msg || '服务内部错误';
          Modal.error({
            title: msg,
            onOk: () => {
              router.go(0);
            }
          });
        } else {
          let msg = error.response.data && error.response.data.error && error.response.data.error.message;
          msg = msg || '服务内部错误';
          Message.error(msg);
        }
        return Promise.reject(error);
      }
    );
  }
  // 创建实例
  create() {
    let conf = {
      baseURL: baseURL,
      // timeout: 2000,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-URL-PATH': location.pathname
      }
    };
    return Axios.create(conf);
  }
  // 合并请求实例
  mergeReqest(instances = []) {
    //
  }
  // 请求实例
  request(options) {
    var instance = this.create();
    this.interceptors(instance, options.url);

    options = Object.assign({}, options);
    this.queue[options.url] = instance;
    return instance(options);
  }

  requestExtraInfo(options) {
    var instance = this.create();
    // 添加请求拦截器
    instance.interceptors.request.use(
      config => {
        let accessToken = sessionStorage.getItem(TOKEN_KEY);
        if (accessToken) {
          config.headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // 在发送请求之前做些什么
        return config;
      },
      error => {
        // 对请求错误做些什么
        return Promise.reject(error);
      }
    );
    // 添加响应拦截器
    instance.interceptors.response.use(
      res => {
        return res;
      },
      error => {
        if (error.response.status === 401) {
          localStorage.clear();
          Message.error('登录失败');
        } else if (error.response.status === 403) {
        } else {
          Message.error('服务内部错误');
        }
        return Promise.reject(error);
      }
    );

    options = Object.assign({}, options);
    this.queue[options.url] = instance;
    return instance(options);
  }
}
export default httpRequest;
